<!--|||||||||||| SIDE MENU ||||||||||||-->
<div id="mySidenav" class="sidenav">

  <div class="row menu-top-section pb-3 d-flex align-items-end justify-content-between">
    <div class="d-flex flex-column ml-3" style="line-height: 1.42;">
      <div style="font-size: 22px; font-weight: 800;">servicenear<span style="color: #FE9000;">.in</span> </div>
      <div style="font-size: 8px; font-weight: 800;">Version {{configService.servicenear_version}}</div>
    </div>
    <div style="width: 30%;">
      <div class="d-flex align-items-center justify-content-center" style="width: 50px; height: 50px;border: 2px solid #FE9000; border-radius: 50%; padding: 2px;">
        <div class="d-flex align-items-center justify-content-center w-100 h-100 " style="background-color:#00BBA6; border-radius: 50%;font-weight: 500;font-size: 20px;  ">
           {{ profileName | slice:0:1 | uppercase}}
        </div>
      </div>
    </div>
  </div>

  <!-- Plan section -->
  <div class="plan-banner p-2" style="line-height: 1.42;">
    <div class="d-flex flex-column justify-content-center align-items-center"
      style="font-size: 10px; font-weight: 600; color: #00BBA6; width: 20%;">
      <span>BASIC</span><span>PLAN</span>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center"
      style="width: 30%; border-left:1px solid rgb(214, 214, 214);border-right:1px solid rgb(214, 214, 214);">
      <div style="font-size: 9px; color: #686868; font-weight: 600;">Jobs Balance</div>
      <div style="font-size: 12px; font-weight: 600; color:#00BBA6;">Unlimited</div>
    </div>
    <div class="d-flex align-items-center flex-grow-1 " style="cursor: pointer;" (click)="goToProfilePage()">
      <div class="d-flex flex-column justify-content-end align-items-center flex-grow-1 pl-4" >
        <div class="ellipsis" style="max-width: 75px; font-size: 9px; font-weight: 300; color:#686868;">{{this.adminDetails?.SellerName}}</div>
        <div class="ellipsis" style="max-width: 75px; font-size: 12px; font-weight: 600; color:#686868;">{{profileName}}</div>
      </div>
      <div class="d-flex align-items-center justify-content-end pt-1 pl-0 ml-0">
        <i style="margin: 0;font-size: 18px; color: #000;" class="bi bi-person-fill"></i>
      </div>
      <div class="ml-1">
        <i style="margin: 0;font-size: 12px;" class="bi bi-chevron-right"></i>
      </div>
    </div>
  </div>

  <!--  $$$$$$$$$$$$$$$$$$ FOR ADMIN $$$$$$$$$$$$$$$$$$  -->

  <div class="menu-scroll pl-0 mt-2">

    <ng-container *ngFor="let item of menuItemsList">
      <ng-container
        *ngIf="!item.hidden && !(item.label === 'Switch to OldUI' && (privilegeService.getServicenearPrivilege('disableSwitchUI', false) || isOldSwithUIHidden))">

        <!-- LINK ITEM -->
        <div *ngIf="item.menuType === 'link' && !item.hidden " class="py-2 px-4 ripple" [class.disabled]="item.disabled">
          <div (click)="gotoPage(item.path)" class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-start">
               <i class="bi m-0" [ngClass]="item.icon" style="font-size: 16px; color: #FE9000;"></i>
              <div class="menu-list">
                  <div class="menu-label">{{ item.label }}</div>
                  <div class="menu-description">{{ item.description }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- EXPANDABLE ITEM -->
        <div *ngIf="item.menuType === 'expandable'  && !item.hidden" class="py-2 px-4 expandable " [class.disabled]="item.disabled">
          <div class="d-flex flex-column" >
            <div class="d-flex align-items-center justify-content-between ripple" (click)="item.expanded = !item.expanded">
              <div class="d-flex align-items-start">
                <i class="bi m-0" [ngClass]="item.icon" style="font-size: 16px; color: #FE9000;"></i>
                <div class="menu-list">
                  <div class="menu-label">{{ item.label }}</div>
                  <div class="menu-description">{{ item.description }}</div>
                </div>
              </div>
              <i class="bi" style="font-size: 0.8rem; color:#fe9000; font-weight:700 !important;-webkit-text-stroke: 0.5px;" 
                [ngClass]="item.expanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>

            <div *ngIf="item.expanded" class="sub-menu pl-3 mt-1">
              <ng-container *ngFor="let subItem of item.children" >
                <div *ngIf="!subItem.hidden" class="d-flex align-items-center justify-content-between ripple">
                  <div class="d-flex align-items-start sub-item py-2 w-100" (click)="gotoPage(subItem.path)" [class.disabledItem]="subItem.disabled">
                    <i class="bi m-0" [ngClass]="subItem.icon" style="font-size: 16px; color: #FE9000;"></i>
                    <div class="menu-list">
                      <div class="menu-label">{{ subItem.label }}</div>
                      <div class="menu-description">{{ subItem.description }}</div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

      </ng-container>
    </ng-container>


  </div>

  <!-- whats new section -->
  <div (click)="gotoContactUsPage()" class="whats-new-banner w-100 mt-3 p-1" style="position: absolute; bottom: 0; left: 0;">
    <div class="ml-3" style="font-size: 10px; font-weight: 600;">
      Contact Us
    </div>
    <div>
      <i class="bi bi-chevron-right" style="font-size: 10px;"></i>
    </div>
  </div>

</div>

<div id="myCloseContainer" (click)="closeSideNav()" class="close-container">
  <div class="d-flex justify-content-end p-1">
    <div class="close-container-btn d-flex justify-content-center align-content-center">
      <i class="material-icons d-flex">close</i>
    </div>
  </div>
</div>